import Url from "url-parse";

function isAnalysisListPath(pathname) {
  // Longer insider paths must come before /analysis and /analizy.
  return /\/(analysis-insider|analizy-insidera|insider-analysis|analysis|analizy)\/?$/i.test(
    pathname || ""
  );
}

/**
 * Rewrites analysis-list hrefs in HTML so they open filtered by stock
 * and optionally by analysis category/type.
 * Matches public and insider list paths (not `/analysis/:id` detail urls).
 */
export function appendStockFilterToAnalysisListLinks(
  html,
  { ticker, market, stockName, categoryId } = {}
) {
  if (!html || !ticker || !market) {
    return html;
  }

  const filterQuery = {
    ticker: String(ticker),
    market: String(market),
    ...(stockName != null && stockName !== ""
      ? { stockName: String(stockName) }
      : {}),
    ...(categoryId != null && categoryId !== ""
      ? { category: String(categoryId) }
      : {})
  };

  return html.replace(/href=(["'])([^"']*)\1/gi, (match, quote, href) => {
    const parsed = new Url(href, {}, true);
    if (!isAnalysisListPath(parsed.pathname)) {
      return match;
    }

    parsed.set("query", {
      ...(parsed.query && typeof parsed.query === "object" ? parsed.query : {}),
      ...filterQuery
    });

    return `href=${quote}${parsed.toString()}${quote}`;
  });
}
